// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"eq-z","slideIn":"fq-z"};